// extracted by mini-css-extract-plugin
export default {"label":"B3Q4FAWPkKr5ZNtxM3tx","navLink":"RQ9uY2F6fHv0eoexlvgw","modelNav":"FLjcsxcmLZ8E9DxbH7_E"};